import VueRouter from "vue-router";

const routes = [
    {
        path:'/',
        name:'login',
        component:()=>import('../components/Login')
    },
    {
        path:'/Index',
        name:'index',
        component:()=>import('../components/Index'),
        children:[
            {
                path:'/Home',
                name:'home',
                meta:{
                    title:'首页'
                },
                component:()=>import('../components/Home')
            },
            {
                path:'/Introduction',
                name:'introduction',
                meta:{
                    title:'介绍'
                },
                component:()=>import('../components/Introduction')
            },
            {
                path:'/Database',
                name:'database',
                meta:{
                    title:'数据'
                },
                component:()=>import('../components/Database')
            },
            {
                path:'/Tool',
                name:'tool',
                meta:{
                    title:'工具'
                },
                component:()=>import('../components/Tool')
            },
            {
                path:'/Advance',
                name:'advance',
                meta:{
                    title:'高级'
                },
                component:()=>import('../components/Advance')
            },
            {
                path:'/Detail',
                name:'detail',
                meta:{
                    title:'详情'
                },
                component:()=>import('../components/Detail')
            },
        ]
    }
]

const router = new VueRouter({
    mode:'history',
    routes
})

export default router;